
export const translations = {
    title:'Productos',
    menu: [{id:1, label:'Todos'}, {id:2, label:'Favoritos'}, {id:3, label:'Más visitados'}, 
           {id:4, label:'Más vendidos'}, {id:5, label:'Nuevos'}, {id:6, label:'Sobresalientes'},
           {id:7, label:'En descuento'},],
}